import "./setupSuperRealTypes";
// Do not import "setupSentry.ts"! It is imported from e.g. "sentry.client.config.ts"
